import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/products/[slug]/ProductDetail.js");
